import { render, staticRenderFns } from "./AcquireDetails.vue?vue&type=template&id=0e1a8e1b"
import script from "./AcquireDetails.vue?vue&type=script&lang=js"
export * from "./AcquireDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports